import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { RichTextStyled } from './styled';
export function RichText({ text, id, paragraphTextColor = colorCoreBlack300 }) {
    const location = useLocation();
    const [isInitialScroll, setIsInitialScroll] = useState(true);
    const handleScroll = useCallback(async () => {
        if (isInitialScroll) {
            // Ignore first scroll (triggered by anchor)
            setIsInitialScroll(false);
            return;
        }
        const pageLevelNavElem = document.querySelector('.page-level-nav');
        pageLevelNavElem?.removeAttribute('style');
        window.removeEventListener('scroll', handleScroll);
    }, [isInitialScroll]);
    useEffect(() => {
        if (location.hash) {
            const menuHeight = document.getElementById('header-portal')?.offsetHeight || 0;
            setTimeout(() => {
                const element = document.getElementById(location.hash.substring(1));
                if (element) {
                    const yOffset = -menuHeight; // menu height
                    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
                    window.scrollTo({
                        top: y,
                        behavior: 'smooth',
                    });
                }
                const pageLevelNavElem = document.querySelector('.page-level-nav');
                if (pageLevelNavElem) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    pageLevelNavElem.style.position = 'absolute';
                }
                window.addEventListener('scroll', handleScroll);
            }, 500);
        }
    }, [handleScroll, location]);
    useEffect(() => {
        window.addEventListener('hashchange', () => {
            setIsInitialScroll(true);
        });
    }, []);
    return (React.createElement(RichTextStyled, { id: id, paragraphTextColor: paragraphTextColor, "data-rte-editelement": true, dangerouslySetInnerHTML: {
            __html: text,
        } }));
}
RichText.displayName = 'RichText_component';
